"use client";

import { Search } from "lucide-react";

export default function RelatedTopics({ topics, onTopicClick }) {
  if (!topics || topics.length === 0) return null;

  return (
    <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-100">
      <h4 className="text-xs font-semibold text-gray-700 mb-2 flex items-center gap-1">
        <Search className="h-3 w-3" />
        Related Topics:
      </h4>
      <div className="space-y-1">
        {topics.map((topic, i) => (
          <button
            key={i}
            onClick={() => onTopicClick(topic)}
            className="block w-full text-left text-xs text-blue-600 hover:text-blue-800 hover:underline py-1 px-2 rounded hover:bg-blue-100 transition-colors"
          >
            → {topic}
          </button>
        ))}
      </div>
    </div>
  );
}
